export const getLastElement = (array) => (array.length ? array[array.length - 1] : []);

export const getLastElementAttr = (array, attr) => getLastElement(array)[attr];

export const isLastElementAttrEqual = (array, attr, value) =>
  getLastElementAttr(array, attr) === value;
